import { render, staticRenderFns } from "./draft_asset.vue?vue&type=template&id=a5e6ce98&scoped=true"
import script from "./draft_asset.vue?vue&type=script&lang=js"
export * from "./draft_asset.vue?vue&type=script&lang=js"
import style0 from "./draft_asset.vue?vue&type=style&index=0&id=a5e6ce98&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e6ce98",
  null
  
)

export default component.exports